import { writable } from 'svelte/store';

// Создаем writable stores
export const basketId = writable(null);
export const basketListnew = writable({ order_items: [] });
